import { useEffect, useState } from 'react';
import { getScrollableParent } from 'helpers/dom/scroll';

/**
 * tracks whether the referenced element is currently visible inside its scroll container
 * @param elementRef - ref pointing at the element to observe
 * @param deps - values that swap the observed element, re-attaching the observer
 */
export default function useIsElementInView(elementRef, deps = []) {
  // assumed visible until proven otherwise, so nothing flashes on the first render
  const [isInView, setIsInView] = useState(true);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) {
      setIsInView(true);
      return undefined;
    }

    // root is set explicitly to the sidebar's own scroll container, so visibility is judged
    // against its scrolled viewport instead of relying on implicit ancestor clipping
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { root: getScrollableParent(element) }
    );
    observer.observe(element);

    return () => observer.disconnect();
  }, deps);

  return isInView;
}
